/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Common_RecommendedInputs */

const en_pc_common_recommended = /** @type {(inputs: Pc_Common_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recommended`)
};

const zh_pc_common_recommended = /** @type {(inputs: Pc_Common_RecommendedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推荐`)
};

/**
* | output |
* | --- |
* | "Recommended" |
*
* @param {Pc_Common_RecommendedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_common_recommended = /** @type {((inputs?: Pc_Common_RecommendedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Common_RecommendedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_common_recommended(inputs)
	return zh_pc_common_recommended(inputs)
});
export { pc_common_recommended as "pc.common.recommended" }